import { Box, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import FormatedTextInput from '@src/App/Components/General/FormularElements/formsControls/inputs/FormatedTextInput/FormatedTextInput';
import type Employee from '@src/Objects/Employee';
import React from 'react';

interface AboutMeWidgetProps {
    employee: Employee;
}

function AboutMeWidget({ employee }: AboutMeWidgetProps) {
    // const theme = useTheme();
    // const OUs = useSelector((state: AppState) => state.OUs);
    // const OU = OUs?.find((o) => o.employees.includes(employee.id));

    return (
        <Paper
            elevation={0}
            sx={{
                p: { lg: 3, md: 2, xs: 2 },
                border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                borderRadius: 2,
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                Über mich
            </Typography>

            {employee.description ? (
                <Box sx={{ mb: 3 }}>
                    <FormatedTextInput value={employee.description} readonly={true} onChange={() => {}} />
                </Box>
            ) : (
                <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic', mb: 3 }}>
                    Noch keine Beschreibung vorhanden
                </Typography>
            )}
        </Paper>
    );
}

export default AboutMeWidget;
